export default __webpack_public_path__ + "static/media/icon-pagination-next.ad6c6666.svg";